import dayjs from "dayjs";
import { PRIMARY_BLUE } from "../../../enums/Colors";

export function calculateAge(birthDateString, t) {
  if (birthDateString == null) {
    return null;
  }

  const birthDate = dayjs(birthDateString, "DD/MM/YYYY");
  const today = dayjs();
  const ageInYears = today.diff(birthDate, "year");
  const isBirthdayToday =
    today.month() === birthDate.month() && today.date() === birthDate.date();

  if (ageInYears < 1) {
    const ageInMonths = today.diff(birthDate, "month");
    const monthLabel = ageInMonths === 1 ? t("SingleMonth") : t("PluralMonths");
    return `${ageInMonths} ${monthLabel}`;
  }

  const isBirthdayPassedThisYear = today.isBefore(
    birthDate.add(ageInYears, "year"),
    "day",
  );

  const finalAge = isBirthdayPassedThisYear ? ageInYears - 1 : ageInYears;
  const ageLabel = "g.";

  return isBirthdayToday
    ? `${finalAge} ${ageLabel} 🎂`
    : `${finalAge} ${ageLabel}`;
}

export const genderEmojiMap = {
  male: "♂️",
  female: "♀️",
};

export function avatarColorCoding(gender) {
  return isFemaleGender(gender) ? "pink" : PRIMARY_BLUE;
}

export const PET_GENDERS = ["MALE", "FEMALE"];

// Older forms stored gender as a switch boolean (true = FEMALE), anything else falls back to MALE
export function normalizePetGender(gender) {
  if (typeof gender === "boolean") return gender ? "FEMALE" : "MALE";
  const upper = String(gender).toUpperCase();
  return PET_GENDERS.includes(upper) ? upper : "MALE";
}

export const isFemaleGender = (gender) =>
  normalizePetGender(gender) === "FEMALE";
